import { makeAutoObservable } from "mobx";
import { IdentifiableMap, RSet } from "../../collections";
import { ProductInstanceHalves, } from "../ProductInstance";
export class HalvesCreatorState {
    constructor(params) {
        this.isSplit = true;
        this.productCategory = params.productCategory;
        this.commonModifierInstanceCreators = params.commonModifierInstanceCreators;
        this.commonCustomParameterInstanceCreators =
            params.commonCustomParameterInstanceCreators;
        this._firstHalf = params.firstHalf;
        this._secondHalf = params.secondHalf;
        this.creatorScopeProvider = params.creatorScopeProvider;
        this.productTypePackagingFeeCreator = params.productTypePackagingFeeCreator;
        makeAutoObservable(this);
    }
    get firstHalf() {
        return this._firstHalf;
    }
    get secondHalf() {
        return this._secondHalf;
    }
    get productCategoryId() {
        return this.productCategory.id;
    }
    get productTypeIds() {
        return RSet.fromIterable([this.firstHalf.productTypeId, this.secondHalf.productTypeId], {
            ignoreDuplicates: true,
        });
    }
    matchesCustomParameterValue(customParameterTypeId, customParameterChoiceId) {
        var _a, _b, _c;
        return ((_c = (_b = (_a = this.commonCustomParameterInstances
            .find(customParameterTypeId)) === null || _a === void 0 ? void 0 : _a.selectedChoice) === null || _b === void 0 ? void 0 : _b.eq(customParameterChoiceId)) !== null && _c !== void 0 ? _c : false);
    }
    get commonModifierInstances() {
        return new IdentifiableMap(this.commonModifierInstanceCreators.raw.map((c) => c.modifierInstance));
    }
    get commonCustomParameterInstances() {
        return new IdentifiableMap(this.commonCustomParameterInstanceCreators.raw.map((c) => c.customParameterInstance));
    }
    get productInstanceParts() {
        return new ProductInstanceHalves({
            productCategory: this.productCategory,
            first: this.firstHalf.productInstancePart,
            second: this.secondHalf.productInstancePart,
        });
    }
    selectInferredDefaults() {
        this.commonModifierInstanceCreators.objects.forEach((m) => m.selectInferredDefaults());
        this.firstHalf.selectInferredDefaults();
        this.secondHalf.selectInferredDefaults();
    }
}
